import {post} from "../../functions";

export async function initStat() {
    const filterForm = document.querySelector('.filter-bar form');
    const filterFormCategory = document.querySelector('.filter-bar input[name="chart-type"]');
    const canvasFrame = document.querySelector('.canvas-frame');

    Chart.defaults.font.family = "'Exo 2', sans-serif";
    Chart.defaults.font.size = 14;

    let datasetList;

    load();

    async function load() {
        const resp = await post('api/stat/data', filterForm)
        console.log(resp);
        datasetList = resp.payload;


        renderChart();
    }

    filterForm.addEventListener('change', () => {
        load();
    })

    filterFormCategory.addEventListener('change', () => {
        renderChart();
    })


    function renderChart() {
        const category = filterFormCategory.value;
        const dataset = datasetList[category];
        canvasFrame.innerHTML = '';

        const config = getCategoryConfigs(category);
        const canvas = document.createElement('canvas');
        canvasFrame.appendChild(canvas);
        config.chartConfig.renderer(canvas, category, Object.keys(dataset), Object.values(dataset), config);

    }

    function renderChartLine(canvas, category, labels, data, config) {
        new Chart(canvas, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    label: config.title,
                    data: data,
                    backgroundColor: '#36A2EB',
                    borderColor: '#36A2EB',
                    borderWidth: 2,
                    tension: 0.2
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {precision: 0}
                    }
                },
                plugins: {
                    title: {
                        display: true,
                        text: config.title,
                        font: {
                            size: 16,
                        }
                    },
                    legend: {
                        position: 'bottom',
                        labels: {
                            font: {
                                size: 14
                            }
                        }
                    },
                }
            }
        });
        return true;
    }

    function renderChartPie(canvas, category, labels, data, config) {
        const myPieChart = new Chart(canvas, {
            type: 'pie',
            data: {
                labels: labels,
                datasets: [{
                    label: config.title,
                    data: data,
                    backgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#4BC0C0',
                        '#9966FF'
                    ],
                    borderColor: '#F9FAFB',
                    borderWidth: 2,
                    hoverOffset: 12
                }]
            },
            options: {
                responsive: true,
                plugins: {
                    title: {
                        display: true,
                        text: config.title,
                        font: {
                            size: 16,
                        }
                    },
                    legend: {
                        position: 'bottom',
                        labels: {
                            font: {
                                size: 14,
                            }
                        },
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                return ` ${context.label}: ${context.raw}%`;
                            }
                        }
                    }
                }
            }
        });
    }

    function getCategoryConfigs(category) {
        const chartTypeData = DATA_CATEGORY_CONFIGS[category] || DATA_CATEGORY_CONFIGS.default;
        const chartConfigData = getChartConfigs(chartTypeData.chart_type);
        return {title: chartTypeData.title, chartConfig: chartConfigData};
    }

    function getChartConfigs(type) {
        return CHART_TYPE_CONFIGS[type] || CHART_TYPE_CONFIGS.default;

    }

    const DATA_CATEGORY_CONFIGS = Object.freeze({
        count: {
            chart_type: 'line',
            title: 'Napi látogatók',
        },
        device_type: {
            chart_type: 'pie',
            title: 'Eszközök szerinti megoszlás',
        },
        os_name: {
            chart_type: 'pie',
            title: 'Operációs rendszer szerinti megoszlás',
        },
        browser: {
            chart_type: 'pie',
            title: 'Böngésző szerinti megoszlás',
        },
        default: {
            chart_type: 'line',
            title: '',
        },
    });

    const CHART_TYPE_CONFIGS = Object.freeze({
        line: {
            renderer: renderChartLine,
        },
        pie: {
            renderer: renderChartPie,
        },
        default: {
            renderer: renderChartLine,
        },
    });
}